import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import classNames from 'classnames/bind';
import Button from '../Button';
import Modal from '../Modal';
import Heading from '../Heading';
import AppLink from '../AppLink';
import { getRoute } from '../../entry/routes';
import styles from './NotAllowedCityModal.styl';

const cx = classNames.bind(styles);

export default function NotAllowedCityModal() {
  const [showModal, setShowModal] = useState(true);
  const cityName = useSelector(state => state.city?.userCity?.name);
  const intl = useIntl();

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <div className={cx('NotAllowedCityModal')}>
      <Button className={cx('NotAllowedCityModal__button')} onClick={() => setShowModal(true)}>
        {intl.formatMessage({ id: 'page.closedCity.modal.button' })}
      </Button>
      {showModal && (
        <Modal className={cx('NotAllowedCityModal__modal')} isOpen={showModal} onClose={closeModal}>
          <div className={cx('NotAllowedCityModal__content')}>
            <Heading tagName="h3" className={cx('NotAllowedCityModal__title')}>
              {intl.formatMessage(
                { id: 'page.closedCity.title' },
                { city: cityName || intl.formatMessage({ id: 'citySelector.modal.title2' }) },
              )}
            </Heading>
            <p className={cx('NotAllowedCityModal__text')}>
              {intl.formatMessage({ id: 'page.closedCity.text' })}
            </p>
            <AppLink className={cx('NotAllowedCityModal__link')} to={getRoute('papabonus')}>
              {intl.formatMessage({ id: 'page.closedCity.papabonusLink' })}
            </AppLink>
          </div>
        </Modal>
      )}
    </div>
  );
}
